import queryString from 'query-string'

export function cloneData(data) {
  return JSON.parse(JSON.stringify(data))
}

export function getQueryParams(url) {
  return queryString.parse(url);
}

export function getQuerryString(parsed) {
  return queryString.stringify(parsed);
}

export function numberWithCommas(value) {
  let num = Number(Math.round(value + 'e' + 2) + 'e-' + 2)
  var num_parts = num.toString().split(".");
  num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return num_parts.join(".");
}

export const scrollToTop = () => {
  // window.scrollTo(0, 0)
  window.scroll({
    top: 0,
    left: 0,
    behavior: 'smooth'
  });
}

export const round = (value, decimals) => {
  return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
}